import React from "react";
import { Menu, UnstyledButton } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import { ReportFilterDef } from "../../../types/reportsV2";
import styles from "./ReportCanvas.module.css";

export interface AddFilterMenuProps {
  /** Filters not yet shown in the toolbar. */
  filters: ReportFilterDef[];
  onAdd: (key: string) => void;
}

/** "+ Filter": adds one of the report's other filters as a toolbar chip. */
export default function AddFilterMenu({ filters, onAdd }: AddFilterMenuProps) {
  if (filters.length === 0) return null;
  return (
    <Menu position="bottom-start" shadow="md" radius="var(--radius-lg)">
      <Menu.Target>
        <UnstyledButton type="button" className={styles.addFilter}>
          <IconPlus size={15} aria-hidden />
          Filter
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>Filter by</Menu.Label>
        {filters.map((f) => (
          <Menu.Item key={f.key} onClick={() => onAdd(f.key)}>
            {f.label}
          </Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
}
